import classes from './TimeBarProgress.module.scss'
import useVideo from "../../hooks/useVideo"
import { useRef } from 'react';
import useSlice from '../../hooks/useSlice';
import clsx from 'clsx';

function TimeBarProgress(props) {
    const { totalDuration, questions } = props;
    const { progress, ref, pause, play } = useVideo();
    const { showSlice, currentQuestionTimeAppear } = useSlice();

    const containerRef = useRef();

    const handleChange = async (e) => {
        const newProgress = Number(e.target.value);
        ref.current.seekTo(newProgress);
    }
    const onPointerDownHandler = () => {
        pause();
    }
    const onPointerUpHandler = () => {
        const pointerInQuestion = !!questions.find(question => {
            const questionTimeAppear = question.timeAppearWithDuration !== null ? question.timeAppearWithDuration : question.timeAppear;
            return progress === questionTimeAppear;
        })
        pointerInQuestion ? pause() : play();
    }

    return (
        <div className={classes.interactiveContainer} ref={containerRef}>
            <div className={classes.totalBar} />
            <div className={classes.progress} style={{ width: (progress / totalDuration) * 100 + "%" }} />
            <input
                onPointerDown={onPointerDownHandler}
                onPointerUp={onPointerUpHandler}
                onChange={handleChange}
                className={clsx(classes.range, currentQuestionTimeAppear === progress && showSlice && classes.dissapearrange)}
                value={progress}
                type="range"
                min="0"
                max={totalDuration}
                step="1"
            />
        </div>
    )
}

export default TimeBarProgress